import { requestOptions } from '@/helpers/request-options'
const Nylas = require('nylas')
const moment = require('moment')

Nylas.config({
  clientId: process.env.NYLAS_CLIENT_ID,
  clientSecret: process.env.NYLAS_SECRET_KEY,
  apiServer: `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/nylas/proxy`
})

export const getContacts = async client => {
  const list = client.contacts.list()
  console.log(list)
  return list
}

export const getClient = accessToken => {
  return Nylas.with(accessToken)
}

const EventFunc = class {
  constructor (event, calendarId, client) {
    this._orig_event = event
    // eslint-disable-next-line no-proto
    Object.keys(event.__proto__).forEach(i => {
      // eslint-disable-next-line no-proto
      this.__proto__[i] = event.__proto__[i]
    })
    this.client = client
    this.calendarId = calendarId
    Object.keys(event).forEach(i => {
      this[i] = event[i]
    })
    for (let attr in event) {
      // if (event.hasOwnProperty(attr)) ; //eslint-disable-line
      this[attr] = event[attr]
    }
    let doc = new DOMParser().parseFromString(this.description, 'text/html')
    this.description_text =
      doc.body.textContent !== 'undefined' ? doc.body.textContent : ''

    if (this.when) {
      this.convertToMoment(this.when)
    }
  }
  convertToMoment (data) {
    if (data) {
      if (data.end_time) {
        this.when.end_time = moment(data.end_time * 1000)
        this.when.object = 'timespan'
      }
      if (data.start_time) {
        this.when.start_time = moment(data.start_time * 1000)
      }

      if (data.time) {
        this.when.start_time = moment(data.time * 1000)
      }
    }
  }
  convertFromMoment (data) {
    if (data.end_date) {
      this.when.end_time = data.end_time.valueOf() / 1000
      delete this.when.object
      this.when.start_time = data.start_time.valueOf() / 1000
    } else if (data.length) {
      this.when.start_time = data[0]
      this.when.end_time = data[1]
    }
  }
  async submit () {
    let ret = false
    this.convertFromMoment(this.when)

    if (this.id) {
      console.log(this)
      ret = await this.save()
    } else {
      ret = await this.create()
    }
    this.convertToMoment(this.when)
    return ret
  }
  async create () {
    console.log(this)

    /* const event = await this.client.events.build({
            title: this.title,
            location: 'My House!',
            when: { start_time: (new Date().getTime()) / 1000 + 3600, end_time: (new Date().getTime()) / 1000 + 7200 },
            //participants: [{ email: 'my.friend@example.com', name: 'My Friend' }],
            calendarId: this.calendarId
          })
        console.log(event)
        return await event.save() */
    const data = {
      participants: this.participants,
      description_text: this.description_text,
      title: this.title,
      calendar_id: this.calendar_id,
      start: this.when[0],
      end: this.when[1],
      deal: this.deal
    }
    console.log(data)
    const response = await fetch(
      `${process.env.VUE_APP_ACTIVE_DOMAIN_URL}/nylas/event/`,
      requestOptions.post(data)
    ).then(handleResponse => handleResponse.json())
    return response.data
  }
}

export const EventListService = class {
  constructor (client, calendar) {
    this.client = client
    this.calendar = calendar
  }

  async getCalendar () {
    const calendars = await this.calendars()
    console.log(calendars)
    this.calendar = calendars.find(i => i.name === 'Calendar')
    console.log('id', this.calendar.id)
  }
  async calendars () {
    const value = await this.client.calendars.list()
    return value
  }

  async list (options) {
    if (!this.calendar) {
      await this.getCalendar()
    }
    options['calendar_id'] = this.calendar.id
    const events = await this.client.events.list(options)
    return events.map(i => new Event(i, this.calendar.id, this.client))
  }
}

export const Event = EventFunc



// WEBPACK FOOTER //
// ./src/services/nylas.service.js